module.exports = __webpack_public_path__ + "assets/img/img_complete.e6437300.svg";